module.exports = __webpack_public_path__ + "img/pc_slogan_01.b2c4ded1.png";